import React, { memo, useContext, useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from 'react-bootstrap/Button'
import '../fichierCss/Evenements.css'
import ReactShadowScroll from 'react-shadow-scroll';
import Image from 'react-bootstrap/Image'
  
const useStyles = makeStyles((theme: Theme) => ({
	root: {
	  width: '100%',
	  maxWidth: '60ch',
	  backgroundColor: theme.palette.background.paper,	  
	},
	inline: {
	  display: 'inline',
	},
  }));
  
interface ImageGeneriqueProps {
  image: string;
  titre: string;
  sousTitre?: string;
  style?: React.CSSProperties;
  fallbackImage?: string;
}

  const ImageGenerique = memo(({ image, titre, sousTitre, style, fallbackImage }: ImageGeneriqueProps) => {
  const [imageSrc, setImageSrc] = React.useState(image);

  React.useEffect(() => {
    setImageSrc(image);
  }, [image]);

  const handleImageError = () => {
    if (fallbackImage && imageSrc !== fallbackImage) {
      setImageSrc(fallbackImage);
    } else {
      setImageSrc('');
    }
  };

	return (
	    <div className="image-generique" style={{ position: 'sticky', top: '1rem', ...style }}>
			{imageSrc && (
				<Image
					src={imageSrc}
					rounded
					width="100%"
					style={{ display: 'block' }}
					onError={handleImageError}
				/>
			)}
			<div className="text-center" style={{ marginTop: image ? '12px' : 0 }}>
				<h3 style={{ fontWeight: 700, fontSize: '1.4rem', color: '#1a3a5c' }}>{titre}</h3>
				{sousTitre && <p style={{ fontSize: '1rem', fontStyle: 'italic', color: '#555' }}>{sousTitre}</p>}
			</div>
		</div>
	);
  } ); 

 export default ImageGenerique;


 